import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import Text from '../text/text';
import { PodiumLinkPopover } from './podium-link-popover';
import { IMeetingRequestParams } from '../../../api/meetings.dao';

export interface IPodiumLinkSectionProps {
    meetingParams: IMeetingRequestParams;
    getPodiumLink: (params: IMeetingRequestParams) => Promise<string>;
    handlePodiumLinkFailure: (e: Error) => void;
    isExpanded?: boolean;
    onCopy: () => void;
}

const PodiumLinkSection = ({
    meetingParams,
    getPodiumLink,
    handlePodiumLinkFailure,
    isExpanded,
    onCopy,
}: IPodiumLinkSectionProps) => {
    const [isPopoverOpen, handleIsOpenPopover] = useState<boolean>(false);
    const buttonItemRef = useRef<HTMLDivElement>(null);
    const classNameLabel = `${isExpanded ? 'control-form__room' : ''}`;
    const buttonClassName = 'connection-list__item--not-started connection-list__item connection-list__item--action';

    return (
        <>
            <label className={classNameLabel}>
                <Text message='Podium' className='oe-form-field__title' />
            </label>
            <div
                className={classnames('connection-list__connection-wrapper', {
                    'connection-list__connection-wrapper__expanded m-left-10px': isExpanded
                })}
                ref={buttonItemRef}
            >
                <button
                    className={classnames(buttonClassName, {
                        'connection-list__item--active': isPopoverOpen,
                        'p-left-35px control-form control-form-connections-item__hoverable': isExpanded,
                        'connection-list__item--hover m-left-27px': !isExpanded
                    })}
                    onClick={e => {
                        e.preventDefault();
                        handleIsOpenPopover(isOpen => !isOpen);
                    }}
                >
                    <Text message='Podium link' withEllipsis />
                </button>
                <PodiumLinkPopover
                    buttonRef={buttonItemRef}
                    isOpen={isPopoverOpen}
                    getPodiumLink={() => getPodiumLink(meetingParams)}
                    onClose={() => handleIsOpenPopover(false)}
                    handlePodiumLinkFailure={handlePodiumLinkFailure}
                    onCopy={onCopy}
                />
            </div>
        </>
    );
};

export default PodiumLinkSection;
